export const leadersData  = [{name: "Player 3", score: 70, id: "2"},
  {name: "Player 6", score: 10, id: "6"},
  {name: "Player 5", score: 20, id: "3"},
  {name: "Player 4", score:50, id: "4"},
  {name: "Player 1", score: 95, id: "5"},
  {name: "Player 2", score: 90, id: "1"},
]

export const mechCollections =[
  {
    matchWon: 1, 
    rank: "Cadet",
    skills: {strength: 10, agilitiy: 75, durability: 45, Eficiency: 60, PilotSkills: 80}, 
    images: {
      main: "https://space-kitties-o283udsl6-jpskonee.vercel.app/static/media/Untitled_Artwork%2016.9f222497.png",
      side: "https://www.spacekitties.xyz/img/sk_3.4da0d671.jpg"
    },
    chart: 1, 
  },
  {
    matchWon: 5, 
    rank: "Hero",
    skills: {strength: 0, agilitiy: 60, durability: 35, Eficiency: 70, PilotSkills: 20}, 
    images: {
      main: "https://space-kitties-o283udsl6-jpskonee.vercel.app/static/media/Untitled_Artwork%2020.33bb64fe.png",
      side: "https://www.spacekitties.xyz/img/53.a0637721.png"
    },
    chart: 2, 
  },
  {
    matchWon: 8, 
    rank: "Super",
    skills: {strength: 80, agilitiy: 70, durability: 50, Eficiency: 75, PilotSkills: 60}, 
    images: {
      main: "https://space-kitties-o283udsl6-jpskonee.vercel.app/static/media/Untitled_Artwork%209.e7cf8e2e.png",
      side: "https://www.spacekitties.xyz/img/sk_10.c4a5bbae.jpg"
    },
    chart: 3, 
  },
  {
    matchWon: 7, 
    rank:"Star",
    skills: {strength: 40, agilitiy: 50, durability: 30, Eficiency: 20, PilotSkills: 60}, 
    images: {
      main: "https://space-kitties-o283udsl6-jpskonee.vercel.app/static/media/mech4.2c7e6fce.png",
      side: "https://www.spacekitties.xyz/img/50.706a55d8.png"
    },
    chart: 2, 
  },
  {
    matchWon: 9, 
    rank: "Master",
    skills: {strength: 25, agilitiy: 5, durability: 55, Eficiency: 45, PilotSkills: 15}, 
    images: {
      main: "https://space-kitties-o283udsl6-jpskonee.vercel.app/static/media/Untitled_Artwork%2021.2a6e3365.png",
      side: "https://www.spacekitties.xyz/img/125.dc037af4.png"
    },
    chart: 1, 
  },
 
]


//dummpy data for the VS screen
export const playerA = {
  mainImg: "https://space-kitties-o283udsl6-jpskonee.vercel.app/static/media/Untitled_Artwork%209.e7cf8e2e.png",
  imgPrev: "https://www.spacekitties.xyz/img/sk_10.c4a5bbae.jpg",
  shield: 50,
  hp: 75,
  gas: 80
}

export const playerB = {
  mainImg:  "https://space-kitties-o283udsl6-jpskonee.vercel.app/static/media/Untitled_Artwork%2021.2a6e3365.png",
  imgPrev: "https://www.spacekitties.xyz/img/125.dc037af4.png",
  shield: 70,
  hp: 65,
  gas: 40
}

